import axios from 'axios';

export const getNTSById = async (id) => {
  const url = `/reports/nts/${id}/?utm_coords=true`;
  const response = await axios.get(url);
  return response;
};
